<ng-container *ngIf="openModal">
    <div class="modal modal-table-payment" @modal>

        <i class="fa-duotone fa-dollar-sign"></i>
        <h2>{{'CardTableInCharge' | i18n : [(isGroupCheck ? 'Table' : 'Card') | i18n]}}</h2>

    </div>
    <div class="overlay"></div>
</ng-container>